import { Component } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  selector: 'app-account-top-up',
  templateUrl: './account-top-up.component.html',
  styleUrl: './account-top-up.component.scss'
})
export class AccountTopUpComponent {
  dataSource: any;

  constructor(private environmentService: EnvironmentService) {
    this.dataSource = {
      store: {
        version: 4,
        type: 'odata',
        key: 'Id',
        url: this.environmentService.getConfig('BackendApi') + 'odata/FundingTransactions'
      }
    };
  }
}
